import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { EmpMissingReportHdrContainer } from '../../../../../../models/aggregates/erp/financial';
import { ApiVisa } from '../../shared/api-visa.model';
import { ApiResponseModel } from '../../shared/api-response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmpMissingReportHdrService extends BaseApiTemplateService<EmpMissingReportHdrContainer> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'emp-missing-report-hdr/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'emp-missing-report-hdr/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'emp-missing-report-hdr/backoffice-ep'
    this.httpClient = http;
  }
     processNow(visa: ApiVisa): Observable<ApiResponseModel<any>> {
      let customUrl;
          // Get the headers from getHttpHeader
          const httpOptions = this.getHttpHeader(visa);
    
          // Add the Content-Type header
          httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
          
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
        customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'emp-missing-report-hdr/process/execute/backoffice-ep'
      }
      return this.httpClient.get<ApiResponseModel<any>>(
        customUrl,
        httpOptions
      );
    }
}
